import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios/axiosInstance";

export const create_province = createAsyncThunk(
    "create/province",async(payload,{rejectWithValue})=>{
        try {
            const { data } = await axiosInstance.post(`/province`,payload,{
                headers:{
                    'Content-Type':'application/json'
                }
            })
            return data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const get_provinces = createAsyncThunk(
    "get/provinces",async(query,{rejectWithValue})=>{
        try {
            const { data }= await axiosInstance.get(`/province`,{
                headers:{
                    'Content-Type':'application/json'
                },
                params:query
            })
            return data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)